/**
 * Generates friendly, playful room names for people who don't want to think one
 * up themselves. Names combine one word from each list — e.g. "Bright Island",
 * "Fresh Heaven" — kept light and a touch whimsical while staying safe for both
 * casual and work settings. Both lists hold unique words only; pairing any
 * adjective with any noun reads naturally.
 */

const ADJECTIVES: readonly string[] = [
  'Bright',
  'Fresh',
  'Cosmic',
  'Sunny',
  'Mellow',
  'Swift',
  'Cozy',
  'Lucky',
  'Gentle',
  'Bold',
  'Clever',
  'Jolly',
  'Calm',
  'Vivid',
  'Witty',
  'Breezy',
  'Snappy',
  'Plucky',
  'Merry',
  'Dapper',
  'Nimble',
  'Chipper',
  'Zesty',
  'Spry',
  'Golden',
  'Quiet',
  'Eager',
  'Crisp',
  'Velvet',
  'Radiant',
  'Stellar',
  'Humble',
  'Wandering',
  'Curious',
  'Brave',
];

const NOUNS: readonly string[] = [
  'Island',
  'Heaven',
  'Harbor',
  'Meadow',
  'Summit',
  'Lagoon',
  'Comet',
  'Garden',
  'Beacon',
  'Haven',
  'Voyage',
  'Orchard',
  'Canyon',
  'Galaxy',
  'River',
  'Willow',
  'Cove',
  'Prairie',
  'Fjord',
  'Glade',
  'Oasis',
  'Nebula',
  'Atlas',
  'Otter',
  'Falcon',
  'Panda',
  'Badger',
  'Lantern',
  'Compass',
  'Harvest',
  'Meridian',
  'Plateau',
  'Aurora',
  'Maple',
  'Brook',
];

const pick = (list: readonly string[]): string => list[Math.floor(Math.random() * list.length)];

/**
 * Returns a random "Adjective Noun" room name. Optionally pass the previously
 * generated name to avoid handing back the exact same name twice in a row, so
 * repeated taps of the generate button feel like they're doing something.
 */
export function generateRoomName(previous?: string): string {
  let name = `${pick(ADJECTIVES)} ${pick(NOUNS)}`;
  // The pool is large enough that a single re-roll reliably differs.
  if (previous && name === previous) {
    name = `${pick(ADJECTIVES)} ${pick(NOUNS)}`;
  }
  return name;
}
